import { motion } from "framer-motion";
import { rem, rgba } from "polished";
import styled, { css } from "styled-components";
import media from "styled-media-query";

import { helpers } from "styles";

import Logo from "assets/porto-seguro-smooth.svg";
import { Container as ContainerComponent } from "components";

type AsideProps = {
  Title?: any;
};

export const Container = styled.div`
  min-height: 100vh;

  display: flex;
`;

export const Aside = {
  Wrap: styled.aside<AsideProps>`
    position: sticky;
    top: 0;

    max-height: 100vh;
    padding: 0 20px;
    overflow: hidden;

    flex: 0.2;

    background-color: ${helpers.gradientWithPrimaryColor};

    ${media.greaterThan("huge")`
      padding: 0 40px;
    `}

    ${media.lessThan("large")`
      display: none;
    `}
  `,

  Content: styled.div`
    height: 100%;
    padding-top: 15vh;
    padding-bottom: 5vh;

    display: flex;
    flex-direction: column;
  `,

  Title: styled.h1`
    color: #fff;
    font-size: ${rem("24px")};

    ${media.greaterThan("huge")`
      font-size: ${rem("32px")};
    `}
  `,

  Description: styled.p`
    padding-top: 24px;

    line-height: 160%;
    font-size: ${rem("10px")};
    color: ${rgba("#FFF", 0.8)};

    ${media.greaterThan("huge")`
      font-size: ${rem("14px")};
    `}
  `,

  Logo: styled.img.attrs({
    src: Logo,
  })`
    margin-top: auto;
    margin-left: -0.5vw;

    width: 20vw;
  `,

  Progress: styled(motion.div)<{ percentage: number }>`
    ${({ percentage }) => css`
      position: relative;

      width: 100%;
      height: 3px;

      border-radius: 6px;
      background-color: ${rgba("#FFF", 0.2)};

      ${media.greaterThan("huge")`
        height: 4px;
      `}

      &:before {
        position: absolute;
        top: -16px;
        left: 4px;

        color: #fff;
        font-weight: bold;
        font-size: ${rem("8px")};
        content: "${percentage}% concluído";

        ${media.greaterThan("huge")`
          top: -22px;

          font-size: ${rem("11px")};
        `}
      }

      &:after {
        position: absolute;
        top: -1.5px;
        left: 0;

        width: ${percentage}%;
        height: 6px;

        content: "";
        border-radius: 6px;
        background-color: #fff;

        ${media.greaterThan("huge")`
          height: 8px;
        `}
      }
    `}
  `,
};

export const Content = styled.div`
  margin-top: 20px;
  padding-bottom: 200px;

  flex: 1;

  ${media.greaterThan("huge")`
    margin-top: 40px;
  `}
`;

export const Box = styled(ContainerComponent)`
  padding: 0 8px;
  margin-top: 30px;
`;

export const Form = styled.form``;

export const ChoiceWrapper = styled.div`
  display: flex;

  > label {
    &:not(:last-of-type) {
      margin-right: 16px;
    }
  }
`;
